/*
  Number format in thousand separator or on to fix decimal digits
*/
import moment from "moment";

const numberFormat = (number, isSeparator = true, decimalDigit = 2) => {
  return isSeparator
    ? new Intl.NumberFormat("en-IN", {
        minimumFractionDigits: decimalDigit,
        maximumFractionDigits: decimalDigit,
      }).format(number)
    : Number(number).toFixed(decimalDigit);
};

/*
  Regex validation by type
*/
const onlyNumbers = (value, type) => {
  // var value = event;
  let regex = "";
  switch (type) {
    case "mediumInt":
      regex = /^[0-9]\d{0,7}$/;
      return value ? regex.test(value) : true;
    case "smallInt":
      regex = /^[0-9]\d{0,4}$/;
      return value ? regex.test(value) : true;
    case "decimal(10,2)":
      regex = /^(?=\d{1,8}(?:\.\d{0,2})?$)\d+(?:\.\d{0,2})?$/;
      return value ? regex.test(value) : true;
    case "-decimal(10,2)":
      regex = /^-?\d{1,8}\.?\d{0,2}|-$/;
      return value ? regex.test(value) : true;
    case "decimal(6,2)":
      regex = /^\d{1,4}\.?\d{0,2}$/;
      return value ? regex.test(value) : true;
    case "decimal(5,2)":
      regex = /^[-]?\d{0,3}\.?\d{0,2}$/;
      return value ? regex.test(value) : true;
    case "pos_percentage":
      regex = /^((?:\.0{1,2})?|(?:\d{1,3}\.)?|(?:\d{1,3}(?:\.\d{1,4})?))$/;
      return value ? regex.test(value) : true;
    case "percentage":
      regex = /^-?((?:\.0{1,2})?|(?:\d{1,3}\.)?|(?:\d{1,3}(?:\.\d{1,4})?)|-|)$/;
      return value ? regex.test(value) : true;
    case "percentage(9,4)":
      regex = /^-?((?:\.0{1,2})?|(?:\d{1,5}\.)?|(?:\d{1,5}(?:\.\d{1,4})?)|-|)$/;
      return value ? regex.test(value) : true;
    case "decimal(12,4)":
      regex = /^\d{1,8}\.?\d{0,4}$/;
      return value ? regex.test(value) : true;
    case "decimal(16,4)":
      regex = /^\d{1,12}\.?\d{0,4}$/;
      return value ? regex.test(value) : true;
    case "-decimal(16,4)":
      regex = /^-?(?=.{1,16}$)\d{1,12}(?:\.(?=\d{1,4}$)\d{1,4})?|-$/;
      return value ? regex.test(value) : true;
    default:
      return false;
  }
};

/*
  Format datetime from utc to local time (12 hours format)
*/

const formatDateTime = (dateString, pattern='DD MMM, YYYY hh:mm A') => {
  return moment.utc(dateString).local().format(pattern);
};

const formatDateTimeTimestamp = (timestamp, pattern = 'DD MMM, YYYY hh:mm A') => {
  return moment(timestamp).local().format(pattern);
};
const formatDate = (date, pattern = 'DD MMM, YYYY') => {
  return moment.utc(dateString).local().format(pattern);
};

const formatPhone = (value) => {
  const cleaned = ('' + value).replace(/\D/g, '');

  if (cleaned.length === 11 && cleaned.startsWith('1')) {
    const countryCode = '+1';  // USA country code
    const areaCode = cleaned.slice(1, 4);
    const centralOfficeCode = cleaned.slice(4, 7);
    const lineNumber = cleaned.slice(7);

    return `${countryCode} (${areaCode}) ${centralOfficeCode}-${lineNumber}`;
  }

  return value;
};
const ucWords = (str) => {
  return str
    .split(/[\s-]+/)                // Split by hyphens
    .map(word =>                // Capitalize each word
      word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join(' ');
}

const convertSecondsToTime = (seconds) => {
  const hours = Math.floor(seconds / 3600); // Get the whole hours
  const minutes = Math.floor((seconds % 3600) / 60); // Get the remaining minutes
  const remainingSeconds = seconds % 60; // Get the remaining seconds

  let timeString = '';

  if (hours > 0) {
    timeString += `${hours}h `;
  }

  if (minutes > 0) {
    timeString += `${minutes}m `;
  }

  timeString += `${remainingSeconds}s`;

  return timeString.trim();
};

/*
  Find the time difference between two times
*/
const timeDifference = (startedAt, endedAt) => {
  var startedAt = new Date(startedAt);
  var endedAt = new Date(endedAt);
  const diffMs = endedAt - startedAt; // milliseconds between startedAt & endedAt
  const diffDays = Math.floor(diffMs / 86400000); // days
  let diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
  diffHrs = diffDays * 24 + diffHrs;
  const diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
  return (
    diffHrs +
    (diffHrs > 1 ? " hours, " : " hour, ") +
    diffMins +
    (diffMins > 1 ? " minutes" : " minute")
  );
};

function amountToWords(amount) {
  const rupees = Math.floor(amount);
  const paise = Math.round((amount - rupees) * 100);
  let words = "";

  if (rupees > 0) {
    words += convertNumber(rupees);
  }

  return words.trim();

  function convertNumber(num) {
    const units = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
    const teens = [
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const tens = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];
    const thousands = ["", "Thousand", "Lakh", "Crore"];

    let words = "";
    let i = 0;

    while (num > 0) {
      const chunk = num % 1000;
      num = Math.floor(num / 1000);
      if (chunk > 0) {
        words =
          convertChunk(chunk) + (i > 0 ? ` ${thousands[i]}` : "") + (words ? ` ${words}` : "");
      }
      i++;
    }

    return words.trim();

    function convertChunk(num) {
      let words = "";
      if (num >= 100) {
        words += `${units[Math.floor(num / 100)]} Hundred`;
        num %= 100;
      }
      if (num > 0) {
        if (words) words += " ";
        if (num < 10) words += units[num];
        else if (num < 20) words += teens[num - 10];
        else {
          words += tens[Math.floor(num / 10)];
          if (num % 10 > 0) words += ` ${units[num % 10]}`;
        }
      }
      return words;
    }
  }
}

function numberToAlphabet(num) {
  if (num < 1 || num > 26) {
    throw new Error("Input must be between 1 and 26");
  }
  return String.fromCharCode(num + 64); // 65 is the ASCII code for 'A'
}

function getOptionLabel(options, key) {
  const match = options.find(option => option.key === key);
  return match ? match.value : "";
}

export { amountToWords, convertSecondsToTime, formatDate, formatDateTime, formatDateTimeTimestamp, formatPhone, getOptionLabel, numberFormat, numberToAlphabet, onlyNumbers, timeDifference, ucWords };

